<template>
  <div class="wlx-tea-train-wrapper">
    <div class="search-input-con">
        <el-input v-model="Title" size="small" style="width:220px;" placeholder="请输入活动标题"/>
        <el-button
          style="margin-left: 10px;"
          size="small"
          type="primary"
          icon="el-icon-search"
          @click="getAttestation()"
        >搜索</el-button>
    </div>
    <div>
      <el-table :data="table" style="width: 100%">
        <el-table-column label="标题" prop="Title"></el-table-column>
        <el-table-column label="内容" prop="ContentText"></el-table-column>
        <el-table-column label="开始时间" prop="PulishTime"></el-table-column>
        <el-table-column label="结束时间" prop="EndTime"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-tooltip class="item" effect="dark" content="点击查看活动内容" placement="top-start">
              <el-button type="primary" size="mini" icon="el-icon-view" @click="seeDetails(scope.row.Content)"></el-button>
            </el-tooltip>
            <el-button type="primary" icon="wl-icon-baoming" size="mini" v-if="scope.row.idSignUp" disabled @click="SignUp(scope.row.Id)"></el-button>
            <el-tooltip class="item" effect="dark" content="点击报名" placement="top-start" v-else>
               <el-button type="primary" icon="wl-icon-baoming" size="mini"  @click="SignUp(scope.row.Id)"></el-button>
            </el-tooltip>
            
           
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="u-page-con">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 40, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount"
      ></el-pagination>
    </div>

    <el-dialog :close-on-click-modal="false" title="活动内容" :visible.sync="dialogVisible" width="30%" :append-to-body="true">
      <span v-html="contentText"></span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog :close-on-click-modal="false" title="完善信息" :visible.sync="dialogVisibleBaseInfo" :append-to-body="true">
      <div>
        <el-form ref="form" :model="form" label-width="100px" class="tea-info-form">
          <el-form-item label="姓名：">
            <el-input v-model="form.Name" @change="updateBasicInfo"></el-input>
          </el-form-item>
          <el-form-item label="头像：">
            <imageUpload
              :url="urlAliyunOSS"
              :files.sync="form.CoverUrl"
              format="image"
              @change="updateBasicInfo"
            ></imageUpload>
          </el-form-item>
          <!-- <el-form-item label="性别：">
            <el-radio-group v-model="form.Gender" @change="updateBasicInfo">
              <el-radio label="0">男</el-radio>
              <el-radio label="1">女</el-radio>
            </el-radio-group>
          </el-form-item> -->
          <el-form-item label="工号：">
            <el-input v-model="form.Number" @change="updateBasicInfo"></el-input>
          </el-form-item>
          <el-form-item label="所在学校:">
            <el-select v-model="form.SchoolId" clearable placeholder="请选择">
              <el-option
                v-for="item in schoolList"
                :key="item.Id"
                :label="item.SchoolName"
                :value="item.Id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="身份证号：">
            <el-input v-model="form.IDNumber" @change="updateBasicInfo"></el-input>
          </el-form-item>
          <!-- <el-form-item label="手机号：">
            <el-input v-model="form.Mobile" @change="updateBasicInfo"></el-input>
          </el-form-item> -->
          <!-- <el-form-item label="简介：">
            <el-input type="textarea" :rows="4" v-model="form.Desc" @change="updateBasicInfo"></el-input>
          </el-form-item> -->
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleBaseInfo = false">取 消</el-button>
        <el-button type="primary" @click="updateBasicInfo">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import imageUpload from "components/imageUpload.vue";
export default {
  data() {
    return {
      attestationList: [],
      SiteList: [],
      siteId_: "",
      totalCount: 0,
      pageSize: 10,
      currentPage: 1,
      table: [],
      Title: "",
      dialogVisible: false,
      dialogVisibleBaseInfo: false,
      contentText: "",
      /****************** */
      form: {
        UserId: "",
        Name: "",
        CoverUrl: "",
        // Gender: "",
        IDNumber: "",
        Number:"",
        // Mobile: "",
        // Desc: "",
        SchoolId: ""
      },
      urlAliyunOSS: "/api/design/osssign/getsign",
      schoolList:[],
    };
  },
  components: {
    imageUpload
  },
  created() {
    this.getAttestation();
    this.getSchoolList();
  },
  methods: {
    getBasicInfo() {
      let self = this;
      this.$http.get("/api/XOrg/teaBasicInfo/getBasicInfo").then(function(res) {
        if (res.code == 1) {
          self.form.UserId = res.userInfo.id;
          self.form.Name = res.userInfo.name;
          self.form.CoverUrl = res.userInfo.cover;
          // self.form.Gender = res.userInfo.gender;
          self.form.IDNumber = res.userInfo.iDNumber;
          self.form.SchoolId = res.userInfo.schoolId;
          self.form.Number = res.userInfo.number;
          // self.form.Mobile = res.userInfo.mobile;
          // self.form.Desc = res.userInfo.description;
        }
      });
    },
    testid(card) {
      var str, result = 0;
        card = card.toUpperCase();
        if (card.length === 18) {
            var map1 = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2],
                map2 = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2'];

            str = new String(card);
            for (var i = 0, len = str.length; i < (len - 1); i++) {
                result += str[i] * map1[i];
            }
            if (map2[(result % 11)] != str[len - 1]) {
                return "请填写正确的身份证号码！"
            }else{
                return "1"
            }
        }else{
          return "请填写正确的身份证号码！";
        }
    },
    updateBasicInfo() {
      let self = this;
      var code= self.testid(this.form.IDNumber);
      if(code!=1){
        this.$message({
          showClose: true,
          message: code,
          type: 'warning'
        });
        return false;
      }
      this.$http
        .post("/api/XOrg/teaBasicInfo/perfectBasicInfo", {
          userId: this.form.UserId,
          name: this.form.Name,
          coverUrl: this.form.CoverUrl,
          // gender: this.form.Gender,
          iDNumber: this.form.IDNumber,
          schoolId: this.form.SchoolId,
          number: this.form.IDNumber,
          // mobile: this.form.Mobile,
          // desc: this.form.Desc
        })
        .then(function(res) {
          if (res.code == 1) {
            self.$message.success(res.msg);
            self.dialogVisibleBaseInfo = false;
          }
        });
    },
    getSchoolList() {
      let self = this;
      this.$http.get("/api/XOrg/StudentManager/getSchoolList").then(function(res) {
        if (res.code == 1) {
          self.schoolList = res.schoolList;
        }
      });
    },
    SignUp(attestationId) {
      var that = this;
      this.$http
        .post("/api/XOrg/StudentManager/addAttestationStu", {
          attestationId: attestationId,
          type: 2
        })
        .then(function(rst) {
          if (rst.code > 0) {
            that.$message.success(rst.msg);
            that.getAttestation();
            // alert(rst.msg);
          } else if ((rst.code == -2)) {
            that.dialogVisibleBaseInfo = true;
            that.getBasicInfo();
          } else {
            that.$message.warning(rst.msg);
            // alert(rst.msg);
          }
        });
    },
    seeDetails(content) {
      this.dialogVisible = true;
      this.contentText = content;
    },
    getAttestation(page) {
      var that = this;
      this.$http
        .post("/api/XOrg/teaCertificate/getAllAttestation", {
          isSys: true,
          Title: this.Title,
          page: page,
          pageSize: this.pageSize
        })
        .then(function(rst) {
          if (rst.code > 0) {
            that.table = rst.enrollList;
            that.totalCount = rst.pagination.totalCount;
            that.pageSize = rst.pagination.pageSize;
            that.currentPage = rst.pagination.pageIndex;
          } else {
            that.$message.warning(rst.msg);
          }
        });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getAttestation();
    },
    handleCurrentChange(val) {
      this.getAttestation(val);
    }
  }
};
</script>

<style lang="scss">
.wlx-tea-train-wrapper {
  .tea-train-form {
    margin: 8px 62px 0 0;
  }
}
</style>
